import * as contentful from 'contentful';

const client = contentful.createClient({
	space: process.env.REACT_APP_CONTENTFUL_SPACE || '',
	accessToken: process.env.REACT_APP_CONTENTFUL_TOKEN || '',
});

// TODO: fetch by title ("prod_content", "dev_content")
const fetchEntries = (contentType: string) =>
	client
		.getEntries({
			content_type: contentType,
			include: 6,
			locale: 'en-US',
		})
		.catch((error: any) => {
			console.error(error);
		});

export const fetchFirstContent = (contentType: string): any =>
	fetchEntries(contentType)
		.then((response: any) => response.items[0].fields)
		.catch((error) => {
			throw error;
		});
